<div class="flexie-auto-grid m-t-b-60">

  <div class="flex-self-vert-start">
    <div *ngIf="!savedAdd">
      <div class="zero-ui">
        <i nz-icon nzType="schedule" nzTheme="outline"></i>
        <h2>Add Contact Number</h2>
        <p>You need to atleast one Contact Number to continue</p>
      </div>
    </div>
    <div *ngIf="savedAdd">
      <h3> Contact Numbers </h3>
      <nz-list [nzDataSource]="list" [nzItemLayout]="'horizontal'" [nzRenderItem]="item">
        <ng-template #item let-item>
          <nz-list-item [nzActions]="[editAction,moreAction]">
            <nz-skeleton [nzActive]="true" [nzLoading]="false">
              <ng-template #moreAction><a (click)="edit(item)">select as Preffered</a></ng-template>
              <ng-template #editAction><a (click)="edit(item)">edit</a></ng-template>
              <ng-template #moreAction><a (click)="view(item)">delete</a></ng-template>
              <nz-list-item-meta [nzTitle]="'Official'" nzDescription="+62 987 9874 9875">
              </nz-list-item-meta>
            </nz-skeleton>
          </nz-list-item>
        </ng-template>
      </nz-list>
    </div>
  </div>

  <div>
    <div class="form-secondary">

      <h3 class="form-secondary-heading">+ Add Contact Number</h3>

      <div class="form-secondary-fields p-l-r-20 p-t-b-10">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Contact Type</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-radio-group nzName="radiogroup" [(ngModel)]="radioValue" name="radiogroup">
              <label nz-radio nzValue="A">Official</label>
              <label nz-radio nzValue="B">Home</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Mobile Number</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input placeholder="Eg: 979879879579" [(ngModel)]="line1" name="input-basic" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24">Extension Number</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input placeholder="Eg: 048695439867" [(ngModel)]="line1" name="input-basic" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24">Country</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input placeholder="Eg: USA" nz-input [(ngModel)]="coc" (input)="onInput($event.target?.value)"
              [nzAutocomplete]="auto">
            <nz-autocomplete [nzDataSource]="filteredOptions" #auto>
            </nz-autocomplete>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div class="footer-actions-bar">
        <div>
          <!-- Left -->
        </div>
        <div>
          <!-- Right -->
          <button nz-button class="b-0 m-r-10">Clear</button>
          <button nz-button [nzType]="'primary'" (click)="savedAdd=!savedAdd">Add</button>
        </div>
      </div>
    </div>
  </div>

</div>
